import '../scss/style.scss';
import '../tailwind.css';

console.log('Theme JS loaded.');
